<template>
<div class="homeIcon" @click="toHome">
  <i class="iconhomeIcon"></i>
</div>
</template>
<script>
export default {
  name: "homeIcon",
  data () {
    return {
    };
  },
  methods:{
    toHome(){
      this.$router.push({name:'home'}) 
    }
  }
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.homeIcon
  width 5.5rem
  height @width
  position fixed
  left 1.5rem
  bottom 20rem
  z-index 999
  .iconhomeIcon
    display block
    height 100%
    width 100%
    bg-image('/static/image/homeIcon/home')
</style>


// WEBPACK FOOTER //
// src/components/common/homeIcon.vue